/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-restricted-imports --
* explicit any is needed to define `QueryProps` and the types it uses correctly,
* and Apollo imports are allowed here.
*/
import React from 'react';
import type { DocumentNode, OperationVariables, TypedDocumentNode } from '~/lazy_apollo/client';

import { Query as ApolloQuery } from '@apollo/client/react/components';
import type { QueryComponentOptions } from '@apollo/client/react/components/types';

export * from '@apollo/client/react/components';

// Extract TData from the query document
export type ExtractDataType<TQuery> = TQuery extends TypedDocumentNode<infer TData, any>
  ? TData
  : Record<string, unknown>;

// Extract TVariables from the query document
export type ExtractVariablesType<TQuery> = TQuery extends TypedDocumentNode<any, infer TVariables>
  ? TVariables
  : OperationVariables;

// Props that infer data and variables from the query document type
export interface QueryProps<TQuery extends DocumentNode | TypedDocumentNode<any, any>> extends Omit<
  QueryComponentOptions<ExtractDataType<TQuery>, ExtractVariablesType<TQuery>>,
  'query'
> {
  query: TQuery;
}

export const Query = <
  TQuery extends DocumentNode | TypedDocumentNode<any, any>
  // @ts-expect-error props are correct, but TypeScript doesn't understand it
>(props: QueryProps<TQuery>) => <ApolloQuery {...props} />;
